export default __webpack_public_path__ + "static/media/bsc.dee11c59.svg";